import { Account } from "../types/Account";
import {
  canPurchaseSubscription,
  canManageExistingSubscription,
} from "./permissions";

export function canUnlockPlanFeature(
  account: Pick<Account, "subscriptions" | "permissions"> | undefined,
) {
  const canPurchase = canPurchaseSubscription({
    account,
    subscriptions: account?.subscriptions,
  });
  const canUpgrade = canManageExistingSubscription({
    subscriptions: account?.subscriptions,
  });
  return canPurchase || canUpgrade;
}
